import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextHyp = () => {

return(
<div>
    
<Typography variant="h6" >
<br />
Hypertension is a major risk factor for heart disease, stroke, kidney failure, and eye problems (Medline). 
Environmental factors also contribute to hypertension. In addition to race and age, activity level, alcohol consumption, and salt intake influence blood pressure. 
Other disorders, such as obesity, diabetes, and obstructive sleep apnea also increase the risk of developing hypertension. 
Hypertension or sustained high blood pressure (≥ 140/90 mmHg) is strongly associated with diabetic complications 
and known as a risk factor for atherosclerotic cardiovascular disease (ASCVD) and microvascular complications
<br /> <br /> 

Because these genes play an integral role in normal blood pressure control, researchers suspect that variations in them might impair blood pressure control and contribute to hypertension.<br /> <br /> 
Drug targets are angiotensin-converting enzyme (ACE) inhibitors and angiotensin II receptor blockers. 
Drugs inhibiting the RAAS pathway such as ACE inhibitors and ARBs are effective treatments for hypertension and cardiac failure.<br /> <br /> 
For the treatment of hypertension, an important drug class is beta-blockers. It is recommended to examine the variants within CYP2D6 for the optimal dosing and avoiding the USE of this drug class 

<br /> <br /> 


<Typography component="span" variant="h5" sx={{fontWeight: '600'}}>Associated Genes: </Typography>
<br /><br />
 
'SH2B3', 'MTHFR', 'CSK', 'ATP2B1', 'PRMD8', 'FGF5', 'ULK4', 'CYP17A1', 'BMPR2', 'BMPR1B', 'CAV1', 'KCNK3', 'SMAD9', 'ACVRL1', 'ENG', 'EIF2AK4', 'UMOD', 'MSX2', 'IFLTD1', 'PTPRD', 'MSX2' 'BNC2', 
 'CYP11B1', 'CYP11B2', 'WNK1', 'WNK4', 'KLHL3', 'CUL3', 'SCNN1B', 'SCNN1G', 'CYP17A', 'HSD11B', 'NR3C2', 'KCNJ5', 'PPAR', 'RET', 'NCCT', 'WNK1', 'WNK2', 'KLHL3', 'CUL3', 'ENaC', 'ROMK2', 'CASZ1', 
 'MTHFR', 'NPPB', 'ST7L', 'CAPZA1', 'MOV10', 'AGT', 'FIGN', 'GRB14', 'SLC4A7', 'ULK4', 'MAP4', 'MECOM', 'FGF5', 'SLC39A8', 'ENPEP', 'GUCY1A3', '1B3', 'NPR3', 'EBF1', 'HFE', 'BAT2', 'BAT3', 'BAT4', 
 'BAT5', 'PIK3CG', 'NOS3', 'BLK', 'GATA4', 'CYP11B2', 'CACNB2', 'PLCE1', 'CYP17A1', 'NT5C2', 'ADRB1', 'ADM', 'PLEKHA7', 'FLJ32810', 'TMEM133', 'ATP2B1', 'SH2B3', 'ALDH2', 'TBX5', 'TBX4', 'TBX3', 'CYP1A1', 
 'ULK3', 'FURIN', 'FES', 'UMOD', 'GOSR2', 'ZNF652', 'JAG1', 'GNAS', 'EDN3'   

<br /><br /> 
 
</Typography>

</div>
)
}